import { render } from "./LibraryArrangement.vue?vue&type=template&id=53bfbec6&scoped=true"
import script from "./LibraryArrangement.vue?vue&type=script&lang=js"
export * from "./LibraryArrangement.vue?vue&type=script&lang=js"

import "./LibraryArrangement.vue?vue&type=style&index=0&id=53bfbec6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53bfbec6"]])

export default __exports__